<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="dedication1">
<h2 class="dedicationText">Books by same author</h2>
<h2 class="dedicationText1"><span class="bold">Autobiography:</span><br/><em class="italic">Flight Testing to Win</em><br/>ISBN 1-4116-4825-0</h2>
<h2 class="dedicationText1"><span class="bold">Mystery Fiction—a Trilogy:</span><br/><em class="italic">A Flight Too Far</em><br/>A mysterious disaster at Heathrow<br/>ISBN 0-9553856-3-6</h2>
<h2 class="dedicationText1"><em class="italic">The Final Flight</em><br/>A Bermuda Triangle mystery<br/>ISBN 0-9553856-0-1</h2>
<h2 class="dedicationText1"><em class="italic">The Right Choice</em><br/>An aviation story of deceit and disaster<br/>ISBN 0-9553856-2-8</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// VulcanTestPilot_dedication1.vue?e8c760e6